export function formatName(client: any) {
  const { firstName, lastName } = client
  const names = [firstName, lastName].filter((name) => Boolean(name)).map((x) => x.trim())
  return names.join(' ')
}
